import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/simp_in/step2';
import { TechAchatFNS } from '../models/TechAchatFNS';
@Component({
	selector: 'app-tech-achatFNS',
	templateUrl: './tech-achatFNS.component.html'
})
export class TechAchatFNSComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TechAchatFNS';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() techAchat: TechAchatFNS;

	public step2 = new Step2();

	public readonly accordCadreValue = 'accordCadre';
	public readonly sysQualiValue = 'sysQuali';
	public readonly sadValue = 'sad';
	public readonly concoursValue = 'concours';
	public readonly catalogueElecValue = 'catalogueElec';
	public readonly enchereElecValue = 'enchereElec';
	public readonly autresValue = 'autres';

	public radioButtonValue: string;
	public radioButtonCtrlName: string;

	constructor() {}

	public ngOnInit() {
		if (this.techAchat.accordCadre === '') {
			this.radioButtonValue = this.accordCadreValue;
		}
		else if (this.techAchat.sysQuali === '') {
			this.radioButtonValue = this.sysQualiValue;
		}
		else if (this.techAchat.sad === '') {
			this.radioButtonValue = this.sadValue;
		}
		else if (this.techAchat.concours === '') {
			this.radioButtonValue = this.concoursValue;
		}
		else if (this.techAchat.catalogueElec === '') {
			this.radioButtonValue = this.catalogueElecValue;
		}
		else if (this.techAchat.enchereElec === '') {
			this.radioButtonValue = this.enchereElecValue;
		}
		else {
			this.radioButtonValue = this.autresValue;
		}
		this.radioButtonCtrlName = this.getUid() + '_SepAtt_accordCadre';
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
